import React from 'react';
import ReactPaginate from "react-paginate";

const Pagination = ({
                        pageCount,
                        params,
                        loading,
                        handlePageClick
                    }) => {
    return (
        pageCount > 1 &&
        <ReactPaginate
            previousLabel={
                <i className="icon-arrow-left"/>
            }
            nextLabel={
                <i className="icon-arrow-right2"/>
            }
            breakLabel="..."
            breakClassName="break-me"
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            disableInitialCallback={true}
            onPageChange={handlePageClick}
            containerClassName={`pagination ${loading ? 'isLoading' : ''}`}
            activeClassName="active"
            disabledClassName="disabled"
            forcePage={
                params?.get('page')
                    ? Number(params.get('page')) - 1
                    : 0
            }
        />
    );
};

export default Pagination;